<template>
	<div class="Newscontent">
		<div class="Newscontent-top">
			<img
				:src="require('@/assets/images/newstop.png')"
				class="image-width"
				alt=""
			/>
		</div>
		<div class="Newscontent-inside">
			<div class="Newscontent-inside-title">
				{{ getLangText(data, 'newsContentTitle') }}
			</div>
			<div class="Newscontent-inside-time">{{ data.newsDate }}</div>
			<div class="Newscontent-inside-cont" v-html="data.newsContentText"></div>
		</div>
	</div>
</template>

<script>
import { getNewsDetail } from '@/api';
import { addPrefixToImgSrc } from '../../utils/image';

export default {
	data() {
		return {
			data: {}
		};
	},
	computed: {
		newsId() {
			return this.$route.query.newsId;
		}
	},
	created() {
		getNewsDetail(this.newsId).then(res => {
			res.newsContent.newsContentText = addPrefixToImgSrc(
				res.newsContent.newsContentText
			);

			this.data = res.newsContent;
		});
	}
};
</script>

<style lang="scss">
@use './Newscontent.scss';
</style>
